import * as React from "react";
import { useTranslation } from "hooks";
import { Typography } from "components";
import { Button } from "@stemscopes/ui";
import { setTextToClipboard } from "components/toolbar/components/actions/components/highlighting/duck/utils";
import styles from "./CambiumCode.module.css";

const CambiumCode: React.FC<{ code: string }> = ({ code }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.inputWrapper}>
        <Typography variant="h3" component="span">
          {code}
        </Typography>
        <Button onClick={() => setTextToClipboard(code)}>Copy</Button>
      </div>

      <Typography variant="p2" className={styles.description} component="span">
        {t("cambium.content")}
      </Typography>
    </div>
  );
};

export default CambiumCode;
